/* Axiom Supply — Polaris Bearing Fitment Check (product page block)
   Type (series) -> Model -> Year -> states FRONT / REAR / FRONT & REAR fitment.
   Data: window.AXIOM_POLARIS_BEARING (assets/polaris-bearing-fitment.js, load first).
   "Message us" opens the Shopify Inbox storefront chat, else follows its href.
   See docs/bearing-fitment.md. */
(function () {
  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.8 10A10 10 0 1 1 17 3.34"/><path d="m9 11 3 3L22 4"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Opens the storefront Shopify Inbox chat (the shop's default messaging).
  // Shopify exposes NO official API for this, so we click the real launcher that
  // Shopify injects AFTER load — the modern <shopify-agent> web component or the
  // legacy #ShopifyChat host — trying several (undocumented) inner selectors.
  // The launcher is injected asynchronously, so we poll briefly. We only call
  // preventDefault() once we actually open the chat; otherwise the link's href
  // (/pages/contact) takes over so the shopper is never stranded.
  function openChat(e) {
    var MAX_WAIT_MS = 2500; // window to wait for the async-injected launcher
    var POLL_MS = 150;
    var started = Date.now();

    // Hosts that may contain the launcher, newest variant first.
    function getHosts() {
      var hosts = [];
      try {
        var nodes = document.querySelectorAll(
          'shopify-agent, [id^="shopify-agent"], #ShopifyChat,' +
          ' [id*="shopify-chat" i], [class*="shopify-chat" i], #shopify-chat'
        );
        for (var i = 0; i < nodes.length; i++) hosts.push(nodes[i]);
      } catch (err) {}
      return hosts;
    }

    // Undocumented inner markup varies across Shopify revisions — try all.
    var TOGGLE_SELECTORS = [
      '.chat-toggle',
      '.chat-app > button',
      'button[aria-label*="chat" i]',
      'button[aria-label*="message" i]',
      '[part="activator"]',
      '.activator',
      '[role="button"]',
      'button'
    ];

    function findToggleIn(root) {
      if (!root) return null;
      for (var i = 0; i < TOGGLE_SELECTORS.length; i++) {
        try { var el = root.querySelector(TOGGLE_SELECTORS[i]); if (el) return el; } catch (err) {}
      }
      return null;
    }

    function findToggle() {
      var hosts = getHosts();
      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];
        try { if (host.shadowRoot) { var s = findToggleIn(host.shadowRoot); if (s) return s; } } catch (err) {}
        var light = findToggleIn(host);
        if (light) return light;
        try {
          if (typeof host.click === 'function' &&
              (host.tagName === 'SHOPIFY-AGENT' || host.id === 'ShopifyChat')) return host;
        } catch (err) {}
      }
      return null;
    }

    function tryClick() {
      try {
        var toggle = findToggle();
        if (toggle && typeof toggle.click === 'function') { toggle.click(); return true; }
      } catch (err) {}
      return false;
    }

    // Fast path: launcher already injected -> open now and block navigation.
    try { if (tryClick()) { if (e && e.preventDefault) e.preventDefault(); return; } } catch (err) {}

    // Not injected yet: hold navigation, poll, then open or fall back to the href.
    var href = (e && e.currentTarget && e.currentTarget.getAttribute)
      ? e.currentTarget.getAttribute('href') : null;
    if (e && e.preventDefault) e.preventDefault();

    var poll = setInterval(function () {
      var opened = false;
      try { opened = tryClick(); } catch (err) {}
      if (opened) { clearInterval(poll); return; }
      if (Date.now() - started >= MAX_WAIT_MS) {
        clearInterval(poll);
        try { window.location.href = href || '/pages/contact'; }
        catch (err) { window.location.href = '/pages/contact'; }
      }
    }, POLL_MS);
  }

  var GROUP_ORDER = ['RZR', 'General', 'Ranger', 'Sportsman', 'Scrambler', 'ACE', 'Xpedition', 'Military', 'Other'];
  var BF = window.AXIOM_POLARIS_BEARING || [];

  if (!window.customElements || customElements.get('bearing-fitment')) return;

  customElements.define(
    'bearing-fitment',
    class extends HTMLElement {
      connectedCallback() {
        this.typeSel = this.q('type');
        this.modelSel = this.q('model');
        this.yearSel = this.q('year');
        this.result = this.q('result');
        if (!this.typeSel || !this.modelSel || !this.yearSel) return;

        this.buildTypes();
        var self = this;
        this.typeSel.addEventListener('change', function () { self.onType(); });
        this.modelSel.addEventListener('change', function () { self.onModel(); });
        this.yearSel.addEventListener('change', function () { self.onYear(); });

        var chat = this.querySelector('[data-bf="chat"]');
        if (chat) chat.addEventListener('click', openChat);
      }

      q(name) { return this.querySelector('[data-bf="' + name + '"]'); }

      ph(sel, label) {
        sel.innerHTML = '';
        sel.add(new Option(label, ''));
      }

      buildTypes() {
        this.ph(this.typeSel, 'Type');
        var self = this;
        GROUP_ORDER.forEach(function (g) {
          if (BF.some(function (e) { return e.group === g; })) self.typeSel.add(new Option(g, g));
        });
      }

      entry() {
        var m = this.modelSel.value;
        for (var i = 0; i < BF.length; i++) if (BF[i].model === m) return BF[i];
        return null;
      }

      onType() {
        var t = this.typeSel.value;
        this.ph(this.modelSel, 'Model');
        this.ph(this.yearSel, 'Year');
        this.yearSel.disabled = true;
        if (t) {
          var self = this;
          BF.forEach(function (e) { if (e.group === t) self.modelSel.add(new Option(e.model, e.model)); });
          this.modelSel.disabled = false;
        } else {
          this.modelSel.disabled = true;
        }
        this.render(null);
      }

      onModel() {
        var e = this.entry();
        this.ph(this.yearSel, 'Year');
        if (e) {
          for (var y = e.end; y >= e.start; y--) this.yearSel.add(new Option(String(y), String(y)));
          this.yearSel.disabled = false;
        } else {
          this.yearSel.disabled = true;
        }
        this.render(null);
      }

      onYear() {
        var e = this.entry();
        var y = +this.yearSel.value;
        if (e && y) this.render(e, y); else this.render(null);
      }

      render(e, y) {
        if (!e || !y) { this.result.hidden = true; this.result.innerHTML = ''; return; }
        var where, cls;
        if (e.front && e.rear) { where = 'FRONT &amp; REAR'; cls = 'is-both'; }
        else if (e.front) { where = 'FRONT'; cls = 'is-front'; }
        else { where = 'REAR'; cls = 'is-rear'; }
        this.result.className = 'bearing-fitment__result ' + cls;
        this.result.hidden = false;
        this.result.innerHTML =
          CHECK +
          '<span><strong>Fits the ' + where + '</strong> of your ' +
          esc(y + ' Polaris ' + e.model) + '.' +
          (e.front && !e.rear ? ' <span class="bearing-fitment__sub">(rear not covered)</span>' : '') +
          '</span>';
      }
    }
  );
})();
